import { isPlatform, alertController } from "@ionic/vue";
import common from '@/common';

let currentAlert: any = null;
const UpdateAlert: any[] = [];

export default async function forceUpdate(fun?: any): Promise<any> {
    if (!isPlatform('hybrid')) {
        if (fun !== undefined) {
            fun();
        }
        return Promise.resolve(0);
    }
    const platform = isPlatform('android') ? 1 : 2;
    const version = isPlatform('android') ? common.config.android_version : common.config.ios_version;
    // 检查是否需要强制更新
    return new Promise((resolve) => {
        common.apiGetData('/checkVersion?platform=' + platform + '&version=' + version, false).then(res => {
            if (res.new_version == 1) {
                alertController.create({
                    cssClass: 'alert',
                    header: '發現新版本',
                    message: '請更新您的應用程式。',
                    mode: 'ios',
                    backdropDismiss: false,
                    buttons: [
                        {
                            text: '馬上更新',
                            handler: () => {
                                location.replace(res.info.download_url);
                            }
                        }
                    ]
                }).then(response => {
                    UpdateAlert.push(response);
                    if (UpdateAlert.length > 1) {
                        currentAlert.dismiss();
                    }
                    currentAlert = response;
                    currentAlert.present();
                });
            }
            else {
                if (fun !== undefined) {
                    fun();
                }
            }
            resolve(res.new_version);
        })
    });
}